{
  "CompetenceDevelopment": "Competence development",
  "Custom": "Custom",
  "InnovationCollaboration": "Innovation collaboration",
  "InnovationCounseling": "Innovation counseling",
  "Internationalization": "Internationalization",
  "OperationalApplication": "Operation application"
}
